import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphMetrics as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphMetricsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphMetrics: React.FC<ParagraphMetricsProps> = ({
  entity,
}) => {
  const paragraphMetrics = entity.toJS();

  const title = paragraphMetrics.field_title[0]?.value;
  const body = paragraphMetrics.field_body[0]?.processed;
  const metricItems = paragraphMetrics.field_paragraphs;

  return (
    <div className="Paragraph ParagraphMetrics">
      <Container>
        <h2>{title}</h2>
        <WysiwygField html={body} />

        {metricItems.length > 0 && (
          <div className="ParagraphMetrics__subparagraphs">
            {metricItems.map((metricItem) => {
              const id = metricItem.target_id;

              return (
                <Paragraph
                  key={`paragraph:${id}`}
                  id={id}
                  entity={Immutable.fromJS(metricItem.entity)}
                />
              );
            })}
          </div>
        )}
      </Container>
    </div>
  );
};

export default ParagraphMetrics;
